import cronstrue from 'cronstrue';

const k8sCronAliases = /* @__PURE__ */ new Map([
  ["@yearly", "0 0 1 1 *"],
  ["@annually", "0 0 1 1 *"],
  ["@monthly", "0 0 1 * *"],
  ["@weekly", "0 0 * * 0"],
  ["@daily", "0 0 * * *"],
  ["@midnight", "0 0 * * *"],
  ["@hourly", "0 * * * *"]
]);
const humanizeCron = (schedule) => {
  const deAliasedSchedule = k8sCronAliases.get(schedule) || schedule;
  try {
    return cronstrue.toString(deAliasedSchedule);
  } catch (e) {
    return deAliasedSchedule;
  }
};

export { humanizeCron };
//# sourceMappingURL=crons.esm.js.map
